import React, { useCallback, useState } from 'react';
import { Card } from 'antd';
import RepossessionTable from './RepossessionTable';
import { useQuery } from 'react-query';
// import { getAssetRepossessionListByAssetID } from '../../../../services/assets';
import { isNil } from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { getAssetRepossessionListByAssetID } from 'services/finassets';

type AssetRepossessionProps = {
  assetid?: number;
};

const AssetRepossession = (props: AssetRepossessionProps) => {
  const { assetid } = props;

  const [selectedContextId, setSelectedContextId] = useState<
    number | undefined
  >();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { data: deprecations } = useQuery(
    ['getAssetRepossessionListByAssetID', { assetid }],
    () =>
      getAssetRepossessionListByAssetID({ assetid: assetid! }).then(
        (res) => res.list || []
      ),
    {
      enabled: !isNil(assetid),
    }
  );

  const selectedDeprecation = selectedContextId
    ? deprecations?.find(({ repid }) => repid === selectedContextId)
    : undefined;

  const onOpenSchedule = useCallback(
    (deprecation) => {
      setSelectedContextId(deprecation.contextid);
      setIsModalVisible(true);
    },
    [setSelectedContextId, setIsModalVisible]
  );

  return (
    <Card title={<GetLabel label="AssetRepossessions" />}>
      <RepossessionTable
        Repossessions={deprecations}
        onOpenSchedule={onOpenSchedule}
      />
    </Card>
  );
};

export default AssetRepossession;
